import { Button, Col, Form, FormProps, Input, Modal, ModalProps, Row, Select, Space, useSelect } from '@pankod/refine-antd'
import { useTable } from '@pankod/refine-core'
import { IQuestionType, IReportTheme, ISubject, ISubTheme, ITheme, ITopic } from 'interfaces'
import React, { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
type CreatePaperTemplateProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  testTrackQueryResult: any
  handleOk: any
  close: any
  sectionId: any
}
export const CloneUpdateSubSection: React.FC<CreatePaperTemplateProps> = ({
  close,
  modalProps,
  formProps,
  record,
  testTrackQueryResult,
  handleOk,
  sectionId,
}) => {
  const { setFilters: setSubjectFilter, tableQueryResult: subjectkQueryResult } = useTable<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    tableQueryResult: topicResult,
    filters: topicFilters,
    setFilters: setTopicFilters,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    filters: reportThemeFilters,
    setFilters: setReportThemeFilters,
    tableQueryResult: reportThemeResult,
  } = useTable<IReportTheme>({
    resource: 'report_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
    // initialFilter: [{ field: 'subject_id', operator: 'eq', value: formProps?.initialValues?.subject_id }],
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })
  useEffect(() => {
    if (record?.test_track_id !== '' && record?.test_track_id !== null && record?.test_track_id !== undefined) {
      setSubjectFilter([
        {
          field: 'id',
          operator: 'in',
          value: testTrackQueryResult?.data?.data[0]?.subject_ids ?? [],
        },
      ])
      //   setShowSubjectData(true)
    } else {
      //   setShowSubjectData(false)
    }
  }, [testTrackQueryResult?.data?.data])
  const handleSubjectChange = (value: { value: any }) => {
    reportThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      report_theme_id: null,
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
    })
    setReportThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleReportThemeChange = (value: { value: any }) => {
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      theme_id: null,
      sub_theme_id: null,
      topic_id: null,
    })
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null, 
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubThemeChange = (value: { value: any }) => {
    topicFilters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: null,
    })
    setTopicFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
  })

  return (
    <Modal {...modalProps} title="Add Sub Section" onOk={handleOk} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values => {
          formProps.form?.resetFields()

          handleOk(values)
        }}
      >
        <Space style={{ display: 'flex', marginBottom: 8 }} align="baseline">
          <Row gutter={[8, 0]}>
            <Col xs={24} lg={3}>
              <Form.Item name={'name'} rules={[{ required: true, message: 'Missing Section' }]}>
                <Input placeholder="Name" type="small" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item name={'subject_id'} rules={[{ required: true }]}>
                <Select placeholder="Subject" onChange={handleSubjectChange}>
                  {subjectkQueryResult?.data?.data?.map((item: any) => (
                    <option value={item?.id}>{item?.name}</option>
                  ))}
                  {/* {subjectList.length > 0 && subjectList.map((item: any) => <option value={item?.id}>{item?.name}</option>)} */}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item
                name={'report_theme_id'}
                //  rules={[{ required: true }]}
              >
                <Select placeholder="Report Theme" onChange={handleReportThemeChange} showSearch>
                  {reportThemeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>{' '}
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item
                name={'theme_id'}
                // rules={[{ required: true }]}
              >
                <Select placeholder="Theme" onChange={handleThemeChange} showSearch>
                  {themeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>{' '}
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item
                name={'sub_theme_id'}
                // rules={[{ required: true }]}
              >
                <Select placeholder="Sub Theme" onChange={handleSubThemeChange}>
                  {subThemeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item
                name={'topic_id'}
                //  rules={[{ required: true }]}
              >
                <Select placeholder="Topic">
                  {topicResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item name={'question_type_id'} rules={[{ required: true }]}>
                <Select {...questionTypeSelectProps} placeholder="Question Type" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item name={'no_of_questions'} rules={[{ required: true, message: 'Missing No of Questions' }]}>
                <Input placeholder="No of Questions" type="small" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item name={'mark_per_question'} rules={[{ required: true, message: 'Missing Marks' }]}>
                <Input placeholder="Mark per Question" type="small" />
              </Form.Item>
            </Col>
            {/* <Form.Item name={'section_id'} initialValue={sectionId}>
              <Input type="hidden" />
            </Form.Item> */}
            <Form.Item name={'id'} initialValue={uuidv4()}>
              <Input type="hidden" />
            </Form.Item>
          </Row>
          {/* <Form.Item name={'paper_template_id'} initialValue={record?.id}>
            <Input type="hidden" />
          </Form.Item> */}
          {/* <MinusCircleOutlined onClick={() => removeSection(item?.id)} /> */}
        </Space>
        <Row style={{ display: 'flex', justifyContent: 'end' }}>
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Space>
          </Col>
        </Row>
        {/* <Form.Item>
            <Button type="dashed" onClick={() => addNewSubSection(currentSectionId)} block icon={<PlusOutlined />}>
              Save
            </Button>
          </Form.Item> */}
      </Form>
    </Modal>
  )
}
